module.exports = __webpack_public_path__ + "static/img/u29.285fc40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kexie/regen/u29.svg
// module id = z88a
// module chunks = 0